import { render, staticRenderFns } from "./data-update.vue?vue&type=template&id=10e28acc&"
import script from "./data-update.vue?vue&type=script&lang=js&"
export * from "./data-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports